import { useCallback, useEffect, useState } from 'react';
import { COUNTDOWN_INTERVAL } from 'common/constants/auth/activation';

const AUTH_RESEND_COOLDOWN_SECONDS = 15;

const useAuthResendCooldown = (initialSeconds = AUTH_RESEND_COOLDOWN_SECONDS) => {
  const [remainingSeconds, setRemainingSeconds] = useState(0);

  const startCooldown = useCallback(() => {
    setRemainingSeconds(initialSeconds);
  }, [initialSeconds]);

  // The resend cooldown only lives in local UI state so we can prevent accidental double-sends
  // without persisting a timer across refreshes or deep links.
  useEffect(() => {
    if (remainingSeconds <= 0) {
      return undefined;
    }

    const timeoutId = window.setTimeout(() => {
      setRemainingSeconds(previousRemainingSeconds => previousRemainingSeconds - 1);
    }, COUNTDOWN_INTERVAL);

    return () => window.clearTimeout(timeoutId);
  }, [remainingSeconds]);

  return {
    isCoolingDown: remainingSeconds > 0,
    remainingSeconds,
    startCooldown,
  };
};

export default useAuthResendCooldown;
